import {
  AGR_EVE_SOWING_ITEM,
  AGR_EVE_IRRIGATION_ITEM,
  AGR_EVE_STAGE_ITEM,
  AGR_EVE_FERTILIZATION_ITEM,
  AGR_EVE_APPLICATION_ITEM,
  AGR_EVE_MONITORING_ITEM,
  AGR_EVE_WEATHER_ITEM,
  AGR_EVE_CULTURAL_ITEM,
  AGR_EVE_HARVEST_ITEM,
} from './agr-eve-types.js'

/** @type {import('../help-index.js').HelpScreen} */
export const AGR_EVE_HELP = {
  screenId: 'agr-eve',
  label: 'Eventos',
  navPath: 'Agro → Eventos',
  keywords: [
    'agro', 'evento', 'siembra', 'riego', 'fertilización', 'fitosanitario',
    'monitoreo', 'granizo', 'cosecha', 'labor cultural', 'aplicación', 'horas', 'mano de obra',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Eventos registrás lo que pasó en cada siembra: siembra, riego, estados, fertilización, aplicaciones, monitoreos, clima, labores y cosecha. Donde hay «Maestros», primero cargá el catálogo y después el Registro.',
  sidebarItems: [
    AGR_EVE_SOWING_ITEM,
    AGR_EVE_IRRIGATION_ITEM,
    AGR_EVE_STAGE_ITEM,
    AGR_EVE_FERTILIZATION_ITEM,
    AGR_EVE_APPLICATION_ITEM,
    AGR_EVE_MONITORING_ITEM,
    AGR_EVE_WEATHER_ITEM,
    AGR_EVE_CULTURAL_ITEM,
    AGR_EVE_HARVEST_ITEM,
  ],
}
